import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated `/warranty/*` URLs.
 *
 * Kept separate from `warranty.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Nested routes compose from their parent's `.path` so the hierarchy stays visible and absolute
 * strings stay in sync (RR6 requires a child's path to start with its parent's).
 */
export const warrantyRoute = defineRoute("/warranty");
export const warrantyDetailsRoute = defineRoute(`${warrantyRoute.path}/:warrantyTicketId`);
